import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "VehicleModelListPage" */
	'pages/vehicle/VehicleModel/VehicleModelListPage'));

export default [{ component, exact: true, path: '/vehicle_models' }];